var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.c{fill-rule:evenodd;}.b,.c{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,0H0V24H24Zm0,0H0V24H24ZM0,24H24V0H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 3.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5,2.083,9.5,2.458a.543.543,0,0,1,0,1.083L5,3.917A.92.92,0,0,1,4,3.076Q4,3.038,4,3a.92.92,0,0,1,.92-.92Q4.958,2.08,5,2.083Z",
    transform: "translate(4 10) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.1,8.675A6.519,6.519,0,0,1,3.75,7.75a31.629,31.629,0,0,1,8,0L13.6,9.6a.5.5,0,0,1,.146.354v.793h0v.793a.5.5,0,0,1-.146.354L11.75,13.75h0a31.629,31.629,0,0,1-8,0A6.519,6.519,0,0,1,1.1,12.825,2,2,0,0,1,.25,11.19V10.31A2,2,0,0,1,1.1,8.675Z",
    transform: "translate(-3.75 17.75) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,8.5V12H11.75a1.75,1.75,0,0,1,1.75,1.75H17A5.25,5.25,0,0,0,11.75,8.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.2b314afc000a5bb38ff47e489f64da9b.svg";
export { ForwardRef as ReactComponent };